import React from "react"
import { Icon, IconButton } from "native-base"
import { Ionicons, MaterialCommunityIcons, FontAwesome5 } from "@expo/vector-icons";
import { IDisposer, onPatch } from "mobx-state-tree";
import { useFocusEffect } from "@react-navigation/native";
import { ITEM_STATUS } from "../../../voolks/types";
import { isElementArchived, openPDF, _findField, checkIsValid } from "../../../utils/itemCommonFunctions";
import { useDebounce, useDebouncedCallback } from "use-debounce";
import { ButtonIcon,Button } from "@gluestack-ui/themed";
import { Platform } from "react-native";
import NetInfo, { NetInfoStateType } from '@react-native-community/netinfo';

export const GetActionButtonsFC = ({ statusStore, itemsStore,formsStore, navigation, setShouldHide, pageActive, form, saveAndGo, forReview,ItemsListScreenName }) => {
  const [isValidItem, setIsValidItem] = React.useState<boolean>(false);
  const [isConnected, setIsConnected] = React.useState<boolean | null>(null);
  console.log("ItemDetailsScreen", "GetActionButtonsFc", "isValidItem", isValidItem, "pageActive", pageActive); 
  const validateItem = () => {
    if (forReview == false && form.pages.length == (pageActive + 1)) {
      console.log("GetActionButtonsFC", "validateItem",statusStore.loadingFieldIdGet());
      const isvalid: boolean = checkIsValid(itemsStore, form) && statusStore.loadingFieldIdGet().length==0;
      isValidItem != isvalid && setIsValidItem(isvalid);
      return isvalid;
    }
    return false;
  }
  const validateItemDebounced = useDebouncedCallback(validateItem, 500);
  useFocusEffect(() => {
    setShouldHide(false);
    validateItem();
    if (forReview != true) {
      let _disposerOnPatch: IDisposer
      _disposerOnPatch = onPatch(itemsStore, patch => {
        validateItemDebounced();
      })
      return () => {
        setShouldHide(true)
        _disposerOnPatch();
      }
    }
    return undefined;
  });
  React.useEffect(() => {

    const unsubscribe = NetInfo.addEventListener((state) => {
      setIsConnected(state.isConnected && state.type == NetInfoStateType.wifi);
    });

    return () => {
      unsubscribe(); // Limpiar la suscripción
    };
  }, [])

  const itemStatus = itemsStore.itemActive.status;
  const upload = async () => {
      if (itemStatus == ITEM_STATUS.draft)
        await itemsStore.saveItemActive(ITEM_STATUS.closed);      
      await itemsStore.upload({ itemIDX: itemsStore.itemActiveIDX });
      saveAndGo();
      if(form.type=="workflow" || form.type=="ptw")
        await formsStore.syncFlows(form.type==="ptw");
      
  }

  const notValid = async (event)=>{
    let retName: string[] = [];
    checkIsValid(itemsStore, form,undefined,retName)
    if(statusStore.loadingFieldIdGet().length>0)
        retName.push("Procesando datos...")
    const hint = retName.join(", ")
    statusStore.setHintMessage("Campos inválidos:", hint, undefined, undefined);
    validateItem();
  }

  const uploadDebounced = useDebouncedCallback(upload, 500);

  if (itemStatus == ITEM_STATUS.draft) {
    if (pageActive != (form.pages.length - 1))
      return <Button width={50} height={50} px="$2" variant="solid" isDisabled={true} key="actionButton-checkHidden" onPress={() => {}}>
      <ButtonIcon as={Ionicons} name="checkmark" color="$primary400"  size="xl"/>                 
    </Button>;
    if (forReview == false)
      return <Button width={50} height={50} px="$2" variant="solid"  key="actionButton-saveToPreview"  onPress={(event: any) => {if(validateItem()) saveAndGo({ goTo: "ItemDetails", forReview: true }); else notValid(event);}}>
      <ButtonIcon as={Ionicons} name="checkmark" color={isValidItem ? "white": "$light400"}  size="xl"/>                 
    </Button>;
    if (forReview == true && (Platform.OS == "web" || isConnected))
      return <><IconButton variant="solid" key="actionButton-uploadItem"
        icon={<Icon as={MaterialCommunityIcons} name="cloud-upload" size="xl" />}
        onPress={uploadDebounced}
      /><IconButton width={50} height={50} variant="solid" key="actionButton-closeItem"
        icon={<Icon as={Ionicons} name="lock-closed" size="xl" />}
        onPress={() => saveAndGo({ goTo: ItemsListScreenName, itemStatus: ITEM_STATUS.closed, forReview: true })}
      /></>;
    if (forReview == true)
      return <IconButton  width={50} height={50} variant="solid" key="actionButton-closeItem"
        icon={<Icon as={Ionicons} name="lock-closed" size="xl" />}
        onPress={() => saveAndGo({ goTo: ItemsListScreenName, itemStatus: ITEM_STATUS.closed, forReview: true })}
      />;
  }

  if (itemStatus == ITEM_STATUS.closed) {
    return <><IconButton variant="solid" isDisabled={itemsStore.itemActive.readOnly == true}
      icon={<Icon key="actionButton-openItem" as={Ionicons} name="lock-open" size="xl" />}
      onPress={() => saveAndGo({ goTo: "ItemDetails", itemStatus: ITEM_STATUS.draft, forReview: false })}
    /><IconButton variant="solid" key="actionButton-uploadItem"
      icon={<Icon as={MaterialCommunityIcons} name="cloud-upload" size="xl" />}
      onPress={uploadDebounced}
      /></>;
  }

  if (itemStatus == ITEM_STATUS.sent) {
    return <><IconButton variant="solid"
      icon={<Icon as={Ionicons} name="mail" size="xl" />}
      onPress={() => openPDF(itemsStore, itemsStore.itemActive, true)}
    /><IconButton variant="solid"
      icon={<Icon as={FontAwesome5} name="file-pdf" size="xl"/>}
      onPress={() => openPDF(itemsStore, itemsStore.itemActive)}
      /></>;
  }
  return <></>;
};